import { render, staticRenderFns } from "./agedService.vue?vue&type=template&id=714ad857&scoped=true&"
import script from "./agedService.vue?vue&type=script&lang=js&"
export * from "./agedService.vue?vue&type=script&lang=js&"
import style0 from "./agedService.vue?vue&type=style&index=0&id=714ad857&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "714ad857",
  null
  
)

export default component.exports